import React, { useState, useEffect, useCallback, useRef} from "react";
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import {  Link } from 'react-router-dom';
import { PROFILE } from 'helpers/viewContent';
import * as Path from 'routes/paths';
import * as actions from 'store/actions/index.js';
import {MAIN__DUMMY_} from 'utils/constant'
// imported
import * as Yup from 'yup';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import {updateProfile_, profile_} from 'store/services/authService';
import { uploadFile_} from 'helpers/uploadFile';

const validationSchema = Yup.object().shape({
    // image: Yup.string().required('Name is required'),
    name: Yup.string().optional(),
    email: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),    
});

const validateData = async (data) => {
    try {
        await validationSchema.validate(data, { abortEarly: false });
        return { isValid: true, errors: {} };
    } catch (error) {
        const errors = {};
        error.inner.forEach((err) => {
            errors[err.path] = err.message;
        });
        return { isValid: false, errors };
    }
};

const Profile = ({dispatch, userProfile}) => {
    const fileInputRef = useRef(null);
    const [validationErrors, setValidationErrors] = useState({});
    const [sending, setSending] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [imageData, setImageData] = useState([]);
    const [fields, setfields] = useState({
        name: "",
        email:"",
        phone: "",
        country_code: "",
        image : ""
    })
    const handleChange = useCallback(
        name => evt => {
          setfields(prevState => ({
            ...prevState,
            [name]: evt.target.value,
          }))
          setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
        },
        []
    )
 
    const handleFileChange = async (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        let fileName = e.target.name;
        dispatch(actions.persist_store({ loader: true }));
        setSending(true)
        let data = await uploadFile_(dispatch, file, setValidationErrors, setSelectedFile, setPreviewImage, fileName)
        data =  data?.length > 0 ? data : [];
        dispatch(actions.persist_store({ loader: false }));
        setSending(false)
        setImageData(data);
    }
    
    const handleDragOver = (e) => {
        e.preventDefault();
    };
    const handleDrop = async (e) => {
        e.preventDefault();
        const file = e.dataTransfer.files[0];
        await uploadFile_ (file);
    };
    const handleClick = () => {
        fileInputRef.current.click();
    };
    //submit setting data
    const handleSubmit = async (evt) => {
    try{
      evt.preventDefault();
      const validation = await validateData(fields);
      if (validation.isValid) {
            const phoneNumberWithoutPlus = fields.phone
            ? fields.phone.substring(fields?.country_code?.length)
            : null;
          const codeWithoutPlus = fields?.country_code;
            let obj = {
                name: fields.name,
                email: fields.email,
                phone: phoneNumberWithoutPlus,
                country_code: fields.country_code
                  ? codeWithoutPlus?.startsWith("+")
                    ? codeWithoutPlus
                    : "+" + codeWithoutPlus
                  : null,
                image : imageData?.length > 0 ? JSON.stringify(imageData) : "",
            }
            setSending(true)
            await dispatch(updateProfile_(obj));
            setSending(false)
            getData();
        } else {
            setValidationErrors(validation.errors);
        }
        } catch (err) {
            console.log(err);
            setSending(false)
        }
    }
    useEffect(() => {
        let data = {
            name:userProfile?.name,
            email:userProfile?.email,
            phone : `${userProfile?.country_code}${userProfile?.phone}`,
            image : `${userProfile?.image}`
        }
        setfields(data)
        setImageData(`${userProfile?.image}`)
    }, [userProfile])
    
    async function getData() {
        try {
          let res = await dispatch(profile_());
          dispatch(actions.persist_store({ userProfile: res.body }));
        } catch (err) {
          console.log(err);
        }
    }

    return(
        <>
        <Helmet title={PROFILE.CURRENT_MODULE} />
        <div className="page-header">
            <h3 className="page-title">
                <span className="page-title-icon bg-gradient-primary text-white me-2">
                <i className="mdi mdi-account"></i>
                </span> Profile
            </h3>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={Path.profile}>{PROFILE.CURRENT_MODULE }</Link></li>
                    <li className="breadcrumb-item active" aria-current="page"></li>
                </ol>
            </nav>
        </div>
        <div className="row">
                <div className="col-md-7">
                    <div className="card">
                        <div className="card-body">
                            <form className="forms-sample" onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <label for="exampleInputName1">Name*</label>
                                    <input type="text" className="form-control" id="exampleInputName1" placeholder="Name" name="name" onChange={handleChange("name")}
                                    value={fields.name}
                                    />
                                    {validationErrors.name && (
                                        <div className="text-danger err">{validationErrors.name}</div>
                                    )}
                                </div>
                                <div className="form-group">
                                    <label for="exampleInputEmail3">Email Address*</label>
                                    <input type="email" className="form-control" id="exampleInputEmail3" placeholder="Email" name="email" onChange={handleChange("email")}
                                    value={fields.email} />
                                    {validationErrors.email && (
                                        <div className="text-danger err">{validationErrors.email}</div>
                                    )} 
                                </div>
                                <div className="form-group">
                                    <label for="exampleInputEmail3">Phone Number</label>
                                    <PhoneInput
                                        enableAreaCodes={true}
                                        name="phone"
                                        className="form-phone_"
                                        country={'us'} // Set the default country, or the one relevant to your use case
                                        value={fields.phone} // Provide the value for the PhoneInput
                                        onChange={(value, country) => {
                                            // Handle phone value change
                                            setfields(prevState => ({
                                            ...prevState,
                                            phone: value,
                                            country_code: country.dialCode,
                                            }));
                                        }}
                                        maxLength={15}
                                    />
                                </div>
                                <div onDrop={handleDrop}  onDragOver={handleDragOver} onClick={handleClick}>
                                    <div className="form-group">
                                        <label for="exampleInputEmail3">Profile Image</label>
                                        <input type="file" class="form-control file-upload-info" disabled="" placeholder="Upload Image" style={{ display: 'none' }} name="image" onChange={(e)=> handleFileChange(e)} ref={fileInputRef}/>
                                        <div>
                                            {previewImage ? (
                                                <img src={previewImage} alt="Preview" className="img-custom" />
                                            ) : userProfile?.image ? (
                                                <img src={userProfile?.image} alt="Preview" className="img-custom" />
                                            ) : (
                                                <img src={MAIN__DUMMY_} alt="Default Preview" className="img-custom" />
                                            )}
                                        </div>
                                        {/* {validationErrors.image && (
                                            <div className="text-danger err">{validationErrors.image}</div>
                                        )} */}
                                    </div>
                                </div>
                            <button type="submit" disabled={sending ? true : false} className="btn btn-gradient-primary me-2">{sending ?  'Loading...' : 'Update'}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}
const mapStateToPros = (state) => {
    return{
        userProfile:  state?.persistStore?.userProfile ? state.persistStore.userProfile :  state.Auth.user,
    }
};
function mapDispatchToProps(dispatch) {
    return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(Profile);